import { makeAutoObservable, runInAction } from 'mobx';

import ApiService from 'src/services/ApiService';
import { DailyHabit } from 'src/models/dailyHabit/DailyHabit';
import { STORE_NAME } from 'src/utils/constants';
import { handleStateError } from 'src/errors';
import { RootStore } from './RootStore';

export default class DailyHabitsStore {
  private storeName = STORE_NAME.ACTIVITIES_STORE;
  private rootStore: RootStore;
  private apiService: ApiService;
  dailyHabits?: DailyHabit;

  constructor(rootStore: RootStore, apiService?: ApiService) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
    this.apiService = apiService || new ApiService(this.rootStore.authStore.getWhsAccessToken);
  }

  loadDailyHabits = async (): Promise<DailyHabit | undefined> => {
    try {
      const dailyHabits = await this.apiService.getDailyHabits();

      if (dailyHabits) {
        runInAction(() => {
          this.dailyHabits = dailyHabits;
        });
      }

      return this.dailyHabits;
    }
    catch (error) {
      handleStateError(error, this.storeName);
    }
  };
}
